function clearStoredUser() {
  try {
    localStorage.removeItem('user');
  } catch {
    // Ignore storage failures during auth recovery.
  }
}

function redirectToLogin() {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname.startsWith('/login')) {
    return;
  }

  window.location.assign('/login');
}

function handleUnauthorizedResponse(status) {
  if (status !== 401 && status !== 403) {
    return;
  }

  clearStoredUser();
  redirectToLogin();
}

export async function fetchAuthenticated(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'include',
    ...options,
  });

  handleUnauthorizedResponse(response.status);
  return response;
}

function buildErrorMessage(response, payload) {
  if (payload && typeof payload === 'object' && typeof payload.message === 'string' && payload.message.trim()) {
    return payload.message.trim();
  }

  if (typeof payload === 'string') {
    const trimmed = payload.trim();
    if (trimmed) {
      if (trimmed.startsWith('<')) {
        const titleMatch = trimmed.match(/<title>([^<]+)<\/title>/i);
        if (titleMatch?.[1]) {
          return titleMatch[1].trim();
        }

        const headingMatch = trimmed.match(/<h1>([^<]+)<\/h1>/i);
        if (headingMatch?.[1]) {
          return headingMatch[1].trim();
        }

        return `HTTP ${response.status}${response.statusText ? ` ${response.statusText}` : ''}`;
      }

      return trimmed;
    }
  }

  return `HTTP ${response.status}${response.statusText ? ` ${response.statusText}` : ''}`;
}

export async function fetchAuthenticatedJson(url, options = {}) {
  const response = await fetchAuthenticated(url, options);
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : await response.text();

  if (!response.ok) {
    throw new Error(buildErrorMessage(response, payload));
  }

  return payload;
}